<template>
    <div class="solution-edu-container">
        <!-- Banner -->
        <div id="solution-edu-pin-target">
            <CommonComponentsTopicSection type="Education" />
            <div class="global-limited-1360px-container">
                <CommonComponentsSolutionsAcademyProcedure />
            </div>
            <CommonComponentsSolutionsAcademyDirections />
        </div>
        <CommonComponentsSolutionsAcademyConstruction />
        <CommonComponentsSolutionsAcademyCourseResource />
        <div class="global-limited-1360px-container">
            <CommonComponentsSolutionsAcademyPartners />
        </div>
    </div>
</template>

<script lang="ts" setup>
    import { onMounted } from 'vue';
    import { addSlideInDown, addSlideInUp, addFadeIn } from '~~/composables/useScrollTrigger';

    onMounted(() => {
        addSlideInUp('.education-slide-in-up');
        addSlideInDown('.education-slide-in-down');
    });
</script>

<style lang="less" scoped>
    .solution-edu-container {
        background-color: #000000;
        width: 100%;

        each(range(0,4,1), {
            .solution-edu-part-@{value} {
                display: flex;
                flex-direction: column;
                align-items: center;
            }
        });
    }

    .academy-center-title {
        text-align: center;
        font-size: .convert(48px) [ @vw];
        margin-top: .convert(60px) [ @vw];
        margin-bottom: .convert(40px) [ @vw];

        @media (max-width: @screen-mobile-width) {
            font-size: 16px;
            margin: 14px 0 22px 0;
        }
    }
</style>
